import React, {useEffect, useState, Suspense} from "react";
import {BackButton, hasPermission, parseURL} from "../../sc-utilities";
import RaspberryEraseStationForm from "./RaspberryEraseStationForm";
import * as Yup from "yup";
import {getTabValue, TabContainer, TabPanel} from "../../sc-order/Order/Details";
import {Dialog, Paper, Tab, Tabs, withStyles} from "@material-ui/core";
import {updateURL} from "../../sc-utilities";
import * as raspberryEraseStationActions from "./store/raspberryEraseStationActions";
import {connect} from "react-redux";
import History from "../../../History";
import AppLogoLoading from "../../sc-logo";
import RaspberryEraseStationPresets from "./RaspberryEraseStationPresets";
import * as actions from "../../sc-customer/Customer/store/customerActions";
import {CancelToken} from "axios";
import {snackActions} from "../../sc-utilities/SnackBar";
import RaspberryEraseStationDebugLogs from "./RaspberryEraseStationDebugLogs";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(5),
        paddingTop: theme.spacing(),
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
    },
    loadingScreen: {
        backgroundColor: "transparent",
        boxShadow: "none",
    },
});

const RaspberryEraseStationDetails = (props) => {
    const {
        classes,
        translations,
        permissions,
        activeCustomerID,
        theme,
        updateRaspberryEraseStation,
        loadRaspberryEraseStation,
        customer,
        onLoadCustomer,
        updatePresets,
        fetchOrders,
        fetchCollies,
        fetchGrades
    } = props;
    const [raspberryEraseStation, setRaspberryEraseStation] = useState(null);
    const [loading, setLoading] = useState(true);
    const [tabValue, setTabValue] = useState(getTabValue());

    const [customerPresetFilter, setCustomerPresetsFilter] = useState({
        orders: [],
        grades: [],
        printers: [],
        collies: [],
        operatingSystems: []
    });

    const presetsCancel = CancelToken?.source();
    const customerCancel = CancelToken?.source();

    const ordersCancel = CancelToken?.source();
    const colliesCancel = CancelToken?.source();
    const gradesCancel = CancelToken.source();
    const printersCancel = CancelToken.source();
    const osCancel = CancelToken.source();

    const {grades, orders, collies} = customerPresetFilter;

    useEffect(() => {
        const fetchData = async () => {
            let orderData = await fetchOrders({
                ActiveCustomerID: activeCustomerID,
                CustomerID: activeCustomerID
            }, {cancelToken: ordersCancel});
            let collies = await fetchCollies({
                ActiveCustomerID: activeCustomerID,
                CustomerID: activeCustomerID
            }, {cancelToken: colliesCancel});
            let grades = await fetchGrades({
                ActiveCustomerID: activeCustomerID,
                CustomerID: activeCustomerID
            }, {cancelToken: gradesCancel});

            if (orderData && collies && grades) {
                setCustomerPresetsFilter({orders: orderData, collies: collies, grades: grades,});
            }
        }

        onLoadCustomer({
            CustomerID: activeCustomerID,
            ActiveCustomerID: activeCustomerID
        }, {cancelToken: customerCancel});
        fetchData();

        return () => {
            ordersCancel.cancel('Operation canceled by the user.');
            customerCancel.cancel('Operation canceled by user');
            colliesCancel.cancel('Operation canceled by the user.');
            gradesCancel.cancel('Operation canceled by the user.');
            printersCancel.cancel('Operation canceled by the user.');
            osCancel.cancel('Operation canceled by the user.');
            presetsCancel.cancel('Operation canceled by the user.');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeCustomerID]);

    const collectPresets = (data) => {
        const presetData = {
            PresetsEnabled: !!data.PresetsEnabled?? false,
            OrderID: data.OrderID?? null,
            TransportColliID: data.TransportColliID?? null,
            ColliID: data.ColliID?? null,
            GradeID: data.GradeID?? null,
            Wifis: data.Wifis?? []
        }
        return presetData;
    }

    const handleSubmit = async data => {
        const presets = collectPresets(data);
        setLoading(true);
        let serverResult = await updatePresets({
            Config: presets,
            RaspberryEraseStationID: raspberryEraseStation.EraseStationID,
            ActiveCustomerID: activeCustomerID
        });
        onLoadCustomer({
            CustomerID: activeCustomerID,
            ActiveCustomerID: activeCustomerID
        }, {cancelToken: customerCancel});

        setLoading(false);
        if (serverResult.status) {
            return snackActions.snackBarComponent(translations['update_presets'] || "Presets updated.", "success");
        } else {
            return snackActions.snackBarComponent(translations['failed_to_update_presets'] || "Error: Failed to update presets", "error");
        }
    };

    const searchParams = parseURL(window.location.href);

    const formSettings = {
        Validation: {
            Name: Yup.string().required("Required")
        },
        FormTitle: translations["edit_raspberry_erase_station"] || "Edit Work Dongle",
        ButtonSubmit: hasPermission(permissions, 'raspberry_erase_station_save') && {Title: translations["save"] || "SAVE"}
    };

    const handleChange = (_event, value) => {
        updateURL(value);
        setTabValue(value);
    };

    const handleEdit = async (data) => {
        const requestData = {...data, ActiveCustomerID: activeCustomerID, RaspberryEraseStationID: searchParams?.EraseStationID}
        const result = await updateRaspberryEraseStation(requestData);
        if (result) {
            History.goBack()
        }
    }

    useEffect(() => {
        const getRaspberryEraseStation = async () => {
            setLoading(true);
            const result = await loadRaspberryEraseStation({
                RaspberryEraseStationID: searchParams?.EraseStationID,
                ActiveCustomerID: activeCustomerID
            });
            setLoading(false);
            if (result) {
                setRaspberryEraseStation(result);
            }
        }

        getRaspberryEraseStation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const initialValues = {
        Name: raspberryEraseStation?.Name || "",
        MajorVersion: raspberryEraseStation?.MajorVersion || "",
        MinorVersion: raspberryEraseStation?.MinorVersion || "",
        BuildNumber: raspberryEraseStation?.BuildNumber || "",
        RemoteID: raspberryEraseStation?.RemoteID || "",
        RemotePassword: raspberryEraseStation?.RemotePassword || "",
        Status: raspberryEraseStation?.Status || "",
        Details: raspberryEraseStation?.Details || "",
    }

    const loadingScreen =   <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={loading} PaperProps={{classes: {root: classes.loadingScreen}}}>
                                <AppLogoLoading/>
                            </Dialog>

    return (
        <>
            {raspberryEraseStation ?
                <>
                    <Paper className={classes.root}>
                        {BackButton(translations)}
                        <Tabs
                            value={tabValue}
                            onChange={handleChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                        >
                            {hasPermission(permissions, 'raspberry_erase_station_load') &&
                            <Tab label={translations['details'] || "Details"} value={0}/>}
                            {hasPermission(permissions, 'raspberry_erase_station_load') &&
                            <Tab label={translations['preset'] || "Preset"} value={1}/>}
                            {hasPermission(permissions, 'raspberry_erase_station_debug_log_list') &&
                            <Tab label={translations['debug_logs'] || "Debug logs"} value={2}/>}
                        </Tabs>
                    </Paper>


                    {hasPermission(permissions, 'raspberry_erase_station_load') &&
                    <TabPanel index={0} value={tabValue} style={{padding: 3 * 3}}>
                        <TabContainer dir={theme.direction}>
                            <Suspense fallback={loadingScreen}>
                                {raspberryEraseStation ? <RaspberryEraseStationForm
                                    formSettings={formSettings}
                                    initialValues={initialValues}
                                    handleSubmit={handleEdit}
                                    translations={translations}
                                /> : loadingScreen}
                            </Suspense>
                        </TabContainer>
                    </TabPanel>}
                    {hasPermission(permissions, 'raspberry_erase_station_load') &&
                    <TabPanel index={1} value={tabValue} style={{padding: 3 * 3}}>
                        <TabContainer dir={theme.direction}>
                            <Suspense fallback={loadingScreen}>
                                <RaspberryEraseStationPresets
                                    translations={translations}
                                    activeCustomerId={activeCustomerID}
                                    handleSubmit={handleSubmit}
                                    updatePresets={updatePresets}
                                    orders={orders}
                                    collies={collies}
                                    grades={grades}
                                    onLoadCustomer={onLoadCustomer}
                                    customer={customer}
                                    loading={loading}
                                    setLoading={setLoading}
                                    loadRaspberryEraseStation={loadRaspberryEraseStation}
                                />
                            </Suspense>
                        </TabContainer>
                    </TabPanel>
                    }
                    {hasPermission(permissions, 'raspberry_erase_station_debug_log_list') && 
                    <TabPanel index={2} value={tabValue} style={{padding: 3 * 3}}>
                        <TabContainer>
                            <Suspense fallback={loadingScreen}>
                            <>
                            <RaspberryEraseStationDebugLogs />
                            </>
                            </Suspense>
                        </TabContainer>
                    </TabPanel>
                    }
                </>
            : loadingScreen}
        </>
    )
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        customer: state?.customer?.customers?.loaded || null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
}

const mapDispatchToProps = dispatch => {
    return {
        loadRaspberryEraseStation: data => dispatch(raspberryEraseStationActions.fetchRaspberryEraseStation(data)),
        updateRaspberryEraseStation: data => dispatch(raspberryEraseStationActions.updateRaspberryEraseStation(data)),
        onLoadCustomer: (customerID, options) => dispatch(actions.loadCustomer(customerID, options)),
        updatePresets: (params, options) => dispatch(raspberryEraseStationActions.updatePresets(params, options)),
        fetchOrders: (id, options) => dispatch(actions.fetchOrders(id, options)),
        fetchCollies: (id, options) => dispatch(actions.fetchCollies(id, options)),
        fetchGrades: (id, options) => dispatch(actions.fetchGrades(id, options)),
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(RaspberryEraseStationDetails));